<template>
  <div class="refund-progress">
    <div
      v-for="item in stepList" 
      :key="item.step"
      class="progress-item"
      :class="getClass(item.step)"
    >
      <img :src="showUrl(item.step)" alt="" class="item-img">
      <div class="item-text">{{item.text}}</div>
    </div>
  </div>
</template>

<script>
import doingIcon from '../images/icon_jingxingzhong@2x.png'
import todoIcon from '../images/icon_weijingxing@2x.png'
import doneIcon from '../images/icon_yiwancheng@2x.png'

export default {
  name: 'RefundProgress',
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      doingIcon,
      todoIcon,
      doneIcon,
      stepList: [{
        step: 1,
        text: '提交申请'
      }, {
        step: 2,
        text: '受理中'
      }, {
        step: 3,
        text: '结果通知'
      }]
    }
  },
  methods: {
    // 判断使用什么图标
    showUrl (step) {
      if (step === this.step) {
        return this.doingIcon
      } else if (step < this.step) {
        return this.doneIcon
      } else {
        return this.todoIcon
      }
    },
    // 根据不同的step返回不同的class类名
    getClass (step) {
      if (step === this.step) {
        return 'current'
      } else if (step < this.step) {
        return 'done'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.refund-progress{
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  &::after{
    content: "";
    display: block;
    height: 3px;
    background-color: #E0DFE5;
    position: absolute;
    top: 28px;
    left: 45px;
    right: 45px;
    z-index: 1;
  }
  .progress-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
    z-index: 2;
    .item-img{
      width: 56px;
      height: 56px;
    }
    .item-text{
      font-size: 24px;
      margin-top: 24px;
      color: #C7C7C7;
    }
    &.current{
      .item-img{
        transform: scale(1.5);
      }
      .item-text{
        color: #FF4633;
      }
    }
    &.done{
      .item-text{
        color: #333333;
      }
    }
  }
}
</style>